import { useState, useCallback } from "react";
import { Theme } from "../types/profile";
import { applyTheme } from "../utils/themeUtils";
import { getTheme } from "../../../services/themeService";

export const useThemeFetcher = () => {
  const [theme, setTheme] = useState<Theme | null>(null);
  const [loading, setLoading] = useState(true);
  const [storedColor, setStoredColor] = useState<Theme[]>([]);

  const fetchTheme = useCallback(async () => {
    try {
      setLoading(true);
      const themes = await getTheme();
      const themeData = themes[0];

      setTheme(themeData);
      setStoredColor(themes);

      if (themeData) {
        applyTheme(themeData);
      }
    } catch (error) {
      console.error("Error fetching theme:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { theme, loading, storedColor, setTheme, setStoredColor, fetchTheme };
};
